import {withTranslation} from "react-i18next";
import SummaryTemplate from "./SummaryTemplate";
import React from "react";
import {parseCage} from "../parsers";
import {makeExtractKeys} from "../../../../utils/FarmMapUtils";
import GlobalConfig from "./GlobalConfig";

const getKeys = makeExtractKeys();

function CageSummary({devices, data, t}) {
    const result = [];
    const keys = getKeys(devices);
    for (let key of keys) {
        const {text, isLive} = parseCage(data[key]);
        result.push(
            <SummaryTemplate
                icon={"fas fa-wheat"}
                header={t("averageWeightAnimal")}
                alerts={data[key]?.Alerts}
                warnings={data[key]?.Warnings}
                isWarning={
                    GlobalConfig.SHOW_OUTDATED_AS_WARNING ? !isLive : false
                }
                content={text}
            />
        );
    }
    return result;
}

export default withTranslation()(CageSummary);
